import React, { useEffect, useRef, useState } from 'react';
import Dashboardnavbarcopy from '../../layout/Dashboardnavbar';
import ReactToPrint from 'react-to-print';
import axios from 'axios';

import { QuotationManagement, Quatations } from './QuatationCRUD';
import Notes from "./Notes";
import { Printer, AddwithWhiteCircle, UpdatePencil, SearchBig, DropdowArrow, Truckbody, Tires, Road } from "../AllSvg";
import { ClientNames, Allclient } from '../AccountDashboardComp/ClientDetails';
import { Modal } from "react-bootstrap";
import WorkType from './WorkType';
import { handleErrorToast } from '../custom';
import QuatationDietails from './QuatationDietails';
import { BASE_URL } from '../../config/axios';
import BankingDietails from './BankingCrud';
import AuthorityDietails from './AuthorityCrud';

// ✅ Set your API base URL here


// ========================= 🔹 INVOICE PAGE =========================
const QuotationSlip = () => {
    const ref = useRef();

    const printButton = (
        <ReactToPrint
            bodyClass="print-agreement"
            content={() => ref.current}
            trigger={() => (
                <button
                    className="model-button model-button-blue"
                    style={{ marginLeft: "10px" }}
                >
                    <Printer /> Print
                </button>
            )}
        />
    );

    return (
        <>
            <div className="flex-column flex-center" style={{ minHeight: "fit-content" }}>
                <div className="printSlip-width flex-row justify-evenly button-margin">
                    {printButton}
                </div>
            </div>
            <QuotationManagement ref={ref} />
        </>
    );
};



// ========================= 🔹 CLIENT DETAILS PAGE =========================
const Quotationmanage = () => {
    const [toggleState, setToggleState] = useState(1);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Work Type Details';
            case 2:
                return 'Notes Details';
                case 3:
                return 'Quotation Details';
                case 4:
                return 'Banking Details';
            default:
                return 'Authority Details';
        }
    };

    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);

    const [worktypeName, setworktypeName] = useState([]);
    const [notesList, setnotesList] = useState([]);
    const [quatationList, setquatationList] = useState([]);
  

    // 🔹 API Calls
    const getworktypeName = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/project/worktype/`);
            setworktypeName(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    const getNotesData = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(`${BASE_URL}/project/note/`);
            setnotesList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false);
        }
    };

    const getQuatationdata = async () => {
        setBuffering2(true);
        try {
            const res = await axios.get(`${BASE_URL}/project/quotations/`);
            setquatationList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering2(false);
        }
    };

    

    useEffect(() => {
        getworktypeName();
        getNotesData();
        getQuatationdata();
        
    }, []);

    return (
        <>
            <Dashboardnavbarcopy url="Quotation Management" name={getSelectedTitle()} />

            <div>
                {/* 🔹 Tab Navigation */}
                <div className="bloc-tabss wfm-margin">
                    <button
                        className={
                            toggleState === 1
                                ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs font-weight400 font-size-subheading"
                        }
                        onClick={() => setToggleState(1)}
                    >
                        Work Type
                    </button>

                    <button
                        className={
                            toggleState === 2
                                ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs font-weight400 font-size-subheading"
                        }
                        onClick={() => setToggleState(2)}
                    >
                        Notes
                    </button>
                    

                    <button
                        className={
                            toggleState === 3
                                ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs font-weight400 font-size-subheading"
                        }
                        onClick={() => setToggleState(3)}
                    >
                        Quotation
                    </button>

                     <button
                        className={
                            toggleState === 4
                                ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs font-weight400 font-size-subheading"
                        }
                        onClick={() => setToggleState(4)}
                    >
                        Banking Details
                    </button>
                    <button
                        className={
                            toggleState === 5
                                ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                : "dashboardcomponent-tabs font-weight400 font-size-subheading"
                        }
                        onClick={() => setToggleState(5)}
                    >
                        Authority Details
                    </button>
                </div>

                {/* 🔹 Tab Content */}
                <div className="content-tabs">
                    {toggleState === 1 && (
                        <WorkType worktypeName={worktypeName} getData={getworktypeName} buffer={buffer} />
                    )}
                    {toggleState === 2 && (
                        <Notes worktypeName={worktypeName} notesData={notesList} getData={getNotesData} buffer={buffer1} />
                    )}
                    {toggleState === 3 && (
                        <QuatationDietails worktypeName={worktypeName} notesData={notesList} quatationData={quatationList} getData={getQuatationdata} buffer={buffer2} />
                    )}

                    {toggleState === 4 && (<BankingDietails/>
                    )}

                     {toggleState === 5 && (<AuthorityDietails/>
                    )}

                </div>
            </div>
        </>
    );
};

export { QuotationSlip, Quotationmanage };
